import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateGiftCardMutation = createMutationHook(GiftCardsApiClient.createGiftCard, {
  mutationKey: ['createGiftCard'],
})
